import { useParams, useSearchParams } from 'react-router-dom';
import { InvoicePayWidget } from '@widgets/invoice-pay';
import { InvoiceThemeProvider } from '@widgets/invoice-pay';
import { isInvoicePayTestingQuery } from '@entities/invoice-pay';

export function InvoicePayPage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const testingMode = isInvoicePayTestingQuery(searchParams.toString());

  return (
    <InvoiceThemeProvider>
      <div className="flex min-h-[100dvh] items-center justify-center bg-[hsl(0_0%_96%)] px-2 py-4 dark:bg-black min-[521px]:px-4 min-[521px]:py-8 sm:py-12">
        <div className="w-full max-w-[540px] min-h-[520px]">
          {id ? <InvoicePayWidget invoiceId={id} testingMode={testingMode} /> : null}
        </div>
      </div>
    </InvoiceThemeProvider>
  );
}
